/**
 * Color scheme
 */
export const COLORS = {
  buttonHover: 'rgba(255, 255, 255, 0.1)',
  primary: '#5865F2',
  primaryDark: '#4752C4',
  speedButtonBg: 'rgba(255, 255, 255, 0.2)',
  speedButtonHover: 'rgba(255, 255, 255, 0.3)',
  waveformPlayed: 'rgba(255, 255, 255, 0.95)',
  waveformUnplayed: 'rgba(255, 255, 255, 0.35)',
  white: '#FFFFFF',
} as const;

/**
 * Default playback speed options
 */
export const DEFAULT_PLAYBACK_SPEEDS = [0.5, 0.75, 1, 1.25, 1.5, 2] as const;

/**
 * Default volume settings
 */
export const DEFAULT_VOLUME = 1;

/**
 * Default number of waveform bars
 */
export const DEFAULT_WAVEFORM_BAR_COUNT = 50;

/**
 * Player size variants
 */
export const PLAYER_SIZES = {
  large: {
    barCount: 60,
    barWidth: 4,
    buttonSize: 44,
    fontSize: '0.95rem',
    height: 64,
    iconSize: 22,
  },
  medium: {
    barCount: 50,
    barWidth: 3,
    buttonSize: 36,
    fontSize: '0.85rem',
    height: 52,
    iconSize: 18,
  },
  small: {
    barCount: 35,
    barWidth: 2,
    buttonSize: 28,
    fontSize: '0.75rem',
    height: 40,
    iconSize: 14,
  },
} as const;

/**
 * Default volume step
 */
export const VOLUME_STEP = 0.01;

/**
 * Default waveform bar dimensions
 */
export const WAVEFORM_BAR_GAP = 2;
export const WAVEFORM_BAR_MIN_HEIGHT = 4;
export const WAVEFORM_BAR_WIDTH = 3;

export type PlaybackSpeed = (typeof DEFAULT_PLAYBACK_SPEEDS)[number];
export type PlayerSize = keyof typeof PLAYER_SIZES;
